import { StandardTextFieldProps } from '@mui/material/TextField/TextField'
import { TextField } from '@mui/material'
import { getGoogleDriveFolderId } from 'infrastructure/googleDrive/urlParser'

export function GDriveFolderIdInput({
  currentId,
  onIdChange,
}: {
  currentId: string
  onIdChange: (id: string) => void
}) {
  const onValueChange: StandardTextFieldProps['onChange'] = (e) => {
    const folderId = getGoogleDriveFolderId(e.target.value)
    onIdChange(folderId)
  }

  return <TextField value={currentId} onChange={onValueChange} />
}
